import React from 'react';
import {Route, Switch} from 'react-router-dom';
import asyncComponent from '../../../util/asyncComponent';


const Pages = ({match}) => (
  <div className="app-wrapper h-100">
    <Switch>
      <Route path={`${match.url}/error-404`} component={asyncComponent(() => import('./routes/404'))}/>
      <Route path={`${match.url}/error-500`} component={asyncComponent(() => import('./routes/500'))}/>
      <Route path={`${match.url}/error-403`} component={asyncComponent(() => import('./routes/403'))}/>
      <Route component={asyncComponent(() => import('app/routes/extraPages/routes/404'))}/>
    </Switch>
  </div>
);

export default Pages;
